import React,{ useState } from 'react';
import { Divider, Loader, Modal, Button } from 'rsuite';
import * as authService from '../../../../app/common/services/fetch.auth.service';
import { NuInsInputPasswordLabel, NuInsSelectGroupLabel, NuInsInputTextLabel, NuInsInputNumLabel } from '../elements/inputFieldsLabel';
import {BackIcon, Vector} from '../svg/iconsSvg';
import countryCodes from '../liabilityPolicy/common/countryCodes.json';

const countryCodesOptions = countryCodes.map((doc, i) => ({label: doc["COUNTRY_NAME"], value: doc["PHONE_CODE"], key: i+1, code: doc["COUNTRY_CODE"] , order: doc["VIEW_ORDER"]}))

const ForgottenPassword = ({onForward, onBack, style}) => {

    const [loginData, setLoginData] = useState({password: null, countryCode: '359', phoneNo: null, email: null});

    const [checkFields, setCheckFields] = useState({});

    const [showModal, setShowModal] = useState({open: false, text: ''});

    const [loading, setLoading] = useState(false);

    const errorMsg = "Полето е задължително";

    const closeModal = () => {
        setShowModal({open: false, text: ''});
    }

    const onChangeHandler = (field, data) =>  {
        if(field === 'countryCode' && data) {
            data = data.substring(1);
        }

        setLoginData({ ...loginData, [field]:data });
    }

    const onBlurHandler = (field) =>  {
       setCheckFields({...checkFields, [field]: true});
    }

    const phoneValidation = () => {
        if(loginData.countryCode  && loginData.phoneNo && loginData.phoneNo.length === 9  ) return true;

        return false;
    }

    const passwordValidation = (password) => {
        const cyrLetters = `аАбБвВгГдДеЕёЁжЖзЗиИйЙкКлЛмМнНоОпПрРсСтТуУфФхХцЦчЧшШщЩъЪыЫьЬэЭюЮяЯ`;
       // (?=.*\d)          // should contain at least one digit
       // (?=.*\D)          // should contain at least one non-digit
       // (?=.*[a-zA-Z${cyrLetters}]) // should contain at least one letter
       // [\Da-zA-Z0-9${cyrLetters}]{6,}   // should contain at least 6 from the mentioned characters
        let regexPassword = `^(?=.*\\d)(?=.*\\D)(?=.*[a-zA-z${cyrLetters}])[\\D0-9a-zA-Z${cyrLetters}]{6,}$`;
        regexPassword = new RegExp(regexPassword);

        return password.match(regexPassword) ? true : false;
    }

    const emailValidation = (email) => {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    const checkForError = (field, type, allFields) =>  {
        
        switch (type) {
            case 'email':
                 return (checkFields[field] || allFields) && (!loginData[field] || !emailValidation(loginData[field]));
            case 'password':
                return (checkFields[field] || allFields) && (!loginData[field] || !passwordValidation(loginData[field]));
            case 'phoneNo':
                return (checkFields[field] || allFields) && (!loginData[field] || !phoneValidation());
            default:
                return (checkFields[field] || allFields) && !loginData[field];
        }
    }

    const generateErrorMsg = (field, type) => {
        switch (type) {
            case 'email':
                if(!loginData[field]) return errorMsg;
                if(loginData[field] && !emailValidation(loginData[field])) return "Невалиден имeил адрес";
                break
            case 'password':
                if(!loginData[field]) return errorMsg;
                if(loginData[field] && !passwordValidation(loginData[field])) return "Невалидна парола";
                break
            case 'phoneNo':
                if(!loginData[field]) return errorMsg;
                break
            default:
                return errorMsg;
        }
    }

    const validateAll = () => {
        if(!loginData.email || !emailValidation(loginData.email)) return false;
        if(!loginData.password || !passwordValidation(loginData.password)) return false;
        if(!loginData.countryCode || !loginData.phoneNo || !phoneValidation()) return false;

        return true;
    }

    const submitHandler = async () => {

        setCheckFields({password: true, phoneNo: true, email: true});

        if(validateAll()) {
            const mobPhone = loginData.countryCode + loginData.phoneNo ;

            setLoading(true)

            let res;

            try {
              res = await authService.requestForgottenPasswordChange(mobPhone, loginData.email);
            } catch (error) {
                setLoading(false);
                console.log(error);
            }

            if(res?.data?.status === 1) {
                setLoading(false);
                if(res?.data?.messageCode === 'INVALID CREDENTIALS') {

                    setShowModal({open: true, text: 'Грешен телефонен номер или имеил'})
                } else if (res?.data?.messageCode === "NDF_PHONE_BY_USER_ID") {

                    setShowModal({open: true, text: 'Липсват данни за този номер'})
                } else {

                    setShowModal({open: true, text: 'Грешка, опитайте отново'});
                }
            } else if (res?.data?.status === 0) {
                const refNo = res?.data?.refNo;

                //setTimeout(()=> onForward({refNo, ...loginData}), 100);
                onForward({refNo, ...loginData})
            }

            console.log(res?.data)  
        }
    }

    const goBack = () => {
        onBack(1)
    }

    return (
        <div className="steps_container" style={style}>
            <div className="head">
                <div className="head-icon" onClick={goBack}><BackIcon size={32}/></div>
                <h6 className="title" style={{marginRight: '48px'}}>Забравена парола</h6>
            </div>
            <Divider />
            <div className="user-login" >
                <div style={{textAlign: 'center'}}> <Vector /></div>

                <div className="address-telephone-container" style={{marginBottom: '.5rem', marginTop: '20px'}}>          
                    <NuInsSelectGroupLabel onChange={(data)=>onChangeHandler('countryCode', data)}
                        value={'+' + loginData.countryCode}
                        placeholder={"Телефон"}
                        options={countryCodesOptions} 
                        ></NuInsSelectGroupLabel>
                        <div style={{marginLeft:'4px'}}>
                            <NuInsInputNumLabel onChange={(data)=>onChangeHandler('phoneNo', data)} onBlur={()=>onBlurHandler('phoneNo')}
                                                validationType={"vin"} slice={9} 
                                                value={loginData.phoneNo}
                                                placeholder={" "}                                  
                                                error= {checkForError('phoneNo', 'phoneNo')}
                                                errorMsg={generateErrorMsg('phoneNo', 'phoneNo')}
                                                /> 
                    </div>       
                </div> 
                <NuInsInputTextLabel onChange={(data)=>onChangeHandler('email', data)} onBlur={()=>onBlurHandler('email')}
                            slice={50}                            
                            placeholder={"Email"} 
                            value={loginData.email} 
                            error={checkForError('email', 'email')} 
                            errorMsg={generateErrorMsg('email', 'email')}
                            styles={{marginBottom: '20px'}}/> 
                <NuInsInputPasswordLabel onChange={(data)=>onChangeHandler('password', data)} onBlur={()=>onBlurHandler('password')}
                            slice={30}                            
                            placeholder={"Нова парола"}
                            value={loginData.password}
                            error={checkForError('password', 'password')}
                            errorMsg={generateErrorMsg('password', 'password')}
                            />
                 <p className="secondary-text" style={{margin: '0 2rem 40px 2rem', fontSize: '10px'}}>
                    Паролата ти трябва да е с дължина поне 6 символа и да съдържа поне една цифра и една буква</p>
                
                <button className="nuIns-btn nuIns-btn-mxd nuIns-btn-main" type="submit" 
                        onClick={submitHandler} >Продължи</button>
            
                {loading ? <Loader backdrop center size="lg" speed="slow" /> : null }
            </div>

            {/* Modal for wrong credential */}
            <Modal size="xs" show={showModal.open} className="nuins-ok-modal" onHide={() => closeModal()}>
                <Modal.Body >
                    <p className="no-reg-data" style={{textAlign: 'center'}}>{showModal.text}</p>    
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => closeModal()} >Ok</Button>
                </Modal.Footer>
            </Modal>
        </div>
    )

}

export default ForgottenPassword;